type RetrieveMenuPresetsResponse = Array<{
  id: string
  title: string
}>

export const listMenuPresets = async () => {
  const { body } =
    await api.get<RetrieveMenuPresetsResponse>(
      `/merchants/menu_presets/`
    )
  return body
}
